import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    setLoading(true);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://saferoster.app/app?reset=true',
    });

    if (error) {
      setError('Error: ' + error.message);
      setLoading(false);
      return;
    }

    setMessage('✅ Password reset email sent! Check your inbox and follow the link to reset your password.');
    setLoading(false);
  };

  return (
    <div>
      <div className="top-bar">
        <button className="btn btn-gray" onClick={onBack}>← Back</button>
      </div>

      <div className="header">
        <h2>🔑 Reset Password</h2>
        <p>Enter your email and we'll send you a reset link</p>
      </div>

      <input
        className="input"
        placeholder="Email Address"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button className="btn btn-primary" onClick={handleReset} disabled={loading}>
        {loading ? 'Sending...' : 'Send Reset Link'}
      </button>

      {message && <div className="success-message">{message}</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default ForgotPassword;